module.exports = __webpack_public_path__ + "img/icon_register_team.2b8376ba.svg";